import { Flex, List } from 'antd';
import ActionHeader from '../../../../components/actionHeader';
import { StyledListItem } from '../../../../styles/listItem';
import { ListContainer } from './styles';
import { useSelector } from 'react-redux';
import IssueCard from '../../../../components/issueCard';
import {
  fetchIssues,
  selectCurrentIssues,
  selectIsFetchingIssues,
  setIssues,
} from '../../../../slices/issues';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../../store';
import {
  selectIsFetchingMachine,
  selectMachine,
} from '../../../../slices/machines';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

const MachineIssues = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const machine = useSelector(selectMachine);
  const isFetchingIssues = useSelector(selectIsFetchingIssues);
  const isFetchingMachine = useSelector(selectIsFetchingMachine);
  const issues = useSelector(selectCurrentIssues);

  const isFetching = isFetchingIssues || isFetchingMachine;

  const handleSearch = (searchText?: string) => {
    if (!isFetchingIssues) {
      dispatch(
        fetchIssues({
          templateID: machine?.templateID,
          params: { search: searchText },
        })
      );
    }
  };

  useEffect(() => {
    if (String(machine?.machineID) !== id) {
      dispatch(setIssues([]));
    }
    if (machine && machine.name) {
      dispatch(fetchIssues({ templateID: machine?.templateID }));
    }
  }, [machine]);
  return (
    <Flex vertical flex={1} gap={8} style={{ height: '100%' }}>
      <ActionHeader
        title={t('issue')}
        isSecondaryTitle
        showBorder={false}
        showSearch
        onSearch={handleSearch}
      />
      <Flex flex={1} style={{ overflowY: 'auto' }}>
        <ListContainer>
          <List
            dataSource={issues}
            loading={isFetching}
            renderItem={(item) => (
              <StyledListItem>
                <IssueCard issue={item} showEdit={false} showDelete={false} />
              </StyledListItem>
            )}
          ></List>
        </ListContainer>
      </Flex>
    </Flex>
  );
};

export default MachineIssues;
